<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>Product Category</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <v-switch 
                        v-model="productCategoryRequest.requiredAtLeastOneProduct"
                        label="At least one product mandatory"
                        :value=1
                        color="var(--color__main)"
                    >
                    </v-switch>
                </v-col>
                <v-col 
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <v-switch 
                        v-model="productCategoryRequest.requiredOnlyOne"
                        label="Must choose only one product"
                        :value=1
                        color="var(--color__main)"
                    >
                    </v-switch>
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    cols="12"
                    lg="9"
                    md="9"
                    sm="12"
                >
                    <label>Description</label>
                    <v-text-field
                        v-model="productCategoryRequest.description" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12"
                    lg="3"
                    md="3"
                    sm="12"
                >
                    <label>Order</label>
                    <v-text-field
                        v-model="productCategoryRequest.order"
                        v-mask="'####'" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <label>Users who approve work order</label>
                    <v-combobox
                        v-model="productCategoryRequest.listIDUserApproveWOSelected"
                        :items="listUser"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        clearable
                        single-line
                        outlined
                        dense
                    >
                        <template v-slot:prepend-item>
                            <v-list-item
                                ripple
                                @mousedown.prevent
                                @click="toggleUsers"
                            >
                                <v-list-item-action>
                                    <v-icon :color="listUser.length > 0 ? 'indigo darken-4' : ''">
                                        {{ iconUser }}
                                    </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Select All
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                    </v-combobox>
                </v-col>
            </v-row>

            <ActionButtons
                :request="productCategoryRequest"
                :loading="loading"
                :showButtons="{
                    cancel: true,
                    save: true
                }"
                @cancel="cancel"
                @save="save"
            />
        </v-form>

    </v-container>
</template>

<script>
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import ActionButtons from "@/components/Layout/ActionButtons";

    export default ({

        mixins: [Helpers],

        components: {
            ActionButtons
        },

        data: () => ({

            validForm: true,

            productCategoryRequest: {
                id: 0,
                requiredAtLeastOneProduct: 0,
                requiredOnlyOne: 0,
                description: "",
                order: 1,
                listIDUserApproveWOSelected: [],
            },
            listUser: [],

            loading: false,
            
            validations: {
                required: required,
            }
        }),

        props: {
            id: {
                default: 0
            }
        },

        computed: {
            allUsers () {
                return this.productCategoryRequest.listIDUserApproveWOSelected != null && 
                       this.productCategoryRequest.listIDUserApproveWOSelected != undefined &&
                       this.productCategoryRequest.listIDUserApproveWOSelected.length === this.listUser.length
            },

            someUsers () {
                return this.productCategoryRequest.listIDUserApproveWOSelected != null && 
                       this.productCategoryRequest.listIDUserApproveWOSelected != undefined &&
                       this.productCategoryRequest.listIDUserApproveWOSelected.length > 0 && !this.allUsers
            },

            iconUser () {
                if (this.allUsers) return 'mdi-close-box'
                if (this.someUsers) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
        },

        methods: {

            toggleUsers () {
                this.$nextTick(() => {
                    if (this.allUsers) {
                        this.productCategoryRequest.listIDUserApproveWOSelected = []
                    } else {
                        this.productCategoryRequest.listIDUserApproveWOSelected = this.listUser.slice()
                    }
                })
            },

            async getLists() {                
                this.listUser = await this.$store.dispatch("userModule/List");
            },
            
            async getRegister() {

                if (this.id !== 0) {

                    let response = await this.$store.dispatch("productCategoryModule/GetById", this.id);

                    if (response.success) {
                        this.productCategoryRequest = response.result;
                    }
                }
                else {
                    this.productCategoryRequest.order = 1;
                }
            },

            async cancel() {
                this.$router.push({ path: "/product/productCategoryList" });
            },

            async save() {

                await this.$refs.form.validate();

                if (this.validForm === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                    return false;
                }
                else {
                    this.loading = true;
                    this.showLoading();

                    this.productCategoryRequest.id = this.id;

                    if (this.productCategoryRequest.requiredAtLeastOneProduct === null) {
                        this.productCategoryRequest.requiredAtLeastOneProduct = 0;
                    }

                    if (this.productCategoryRequest.requiredOnlyOne === null) {
                        this.productCategoryRequest.requiredOnlyOne = 0;
                    }

                    if (this.productCategoryRequest.listIDUserApproveWOSelected != null && this.productCategoryRequest.listIDUserApproveWOSelected != undefined) {
                        this.productCategoryRequest.listIDUserApproveWO = '';

                        this.productCategoryRequest.listIDUserApproveWOSelected.forEach(item => {
                            this.productCategoryRequest.listIDUserApproveWO += `${item.id};`
                        });
                    }

                    const result = await this.$store.dispatch("productCategoryModule/CreateUpdate", this.productCategoryRequest);

                    if (result.success === true) {
                        this.showToast("success", "Success!", result.message);
                        this.cancel();
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                    }

                    this.loading = false;
                    this.hideLoading();
                        
                }
            }
        },

        created() {
            this.showLoading();

            this.getLists();
            this.getRegister();

            this.hideLoading();
        }
    })
</script>